import { RequestState } from 'vrlcm-gui-types';
import { UpgradeWorkflow } from '../types/workflows/UpgradeWorkflow';

export const upgradeWorkflow: UpgradeWorkflow = {
  fetching: true,
  fetchingFailed: false,
  submitStatus: {
    submitting: false,
    failed: false
  },
  state: {
    requestId: '',
    requestState: RequestState.UI_INPROGRESS,
    uiData: '{}',
    resultData: '',
    upgradeProductRequestDTO: {
      environmentId: '',
      preValidate: false,
      productId: '',
      productVersion: '',
      repositoryType: 'Default',
      repositoryUrl: '',
      snapshotIaasAfterVaUpgrade: false,
      migrations: [],
      tenantId: '',
      takeProductSnapshot: false,
      retainProductSnapshot: false
    }
  }
};
